import React, { useState, useEffect } from "react";
import {
  Facebook,
  Instagram,
  WhatsApp,
  Chat as ChatIcon,
} from "@material-ui/icons";
import TelegramIcon from "@mui/icons-material/Telegram";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import SmsIcon from "@mui/icons-material/Sms";
import EmailIcon from "@mui/icons-material/Email";
import ForumIcon from "@mui/icons-material/Forum";
import WebhookIcon from "@mui/icons-material/Webhook";
import { runPluginScripts } from "@markedesk/plugin-sdk/ui";
import api from "../../services/api";

const iconMap = {
  WhatsApp,
  Facebook,
  Instagram,
  Telegram: TelegramIcon,
  SmartToy: SmartToyIcon,
  Webhook: WebhookIcon,
  Sms: SmsIcon,
  Email: EmailIcon,
  Forum: ForumIcon,
  Chat: ChatIcon,
};

export const nativeChannels = {
  whatsapp: { icon: "WhatsApp", color: "#25d366" },
  whatsapp_oficial: { icon: "WhatsApp", color: "#25d366" },
  facebook: { icon: "Facebook", color: "#3b5998" },
  instagram: { icon: "Instagram", color: "#e1306c" },
};

// Cache compartilhado entre todas as instâncias
let pluginsCache = null;
let pluginsPromise = null;

function fetchPlugins() {
  if (pluginsCache) return Promise.resolve(pluginsCache);
  if (pluginsPromise) return pluginsPromise;
  pluginsPromise = api
    .get("/plugins")
    .then(({ data }) => {
      pluginsCache = data;
      // Executa os scripts de UI dos plugins (provides.frontendScript)
      try {
        runPluginScripts(data);
      } catch (e) { /* ignore */ }
      return data;
    })
    .catch(() => {
      pluginsCache = [];
      return [];
    });
  return pluginsPromise;
}

const listeners = new Set();

export function clearPluginsCache() {
  pluginsCache = null;
  pluginsPromise = null;
  // Refetch e notificar todos os hooks
  fetchPlugins().then((data) => {
    listeners.forEach((fn) => fn(data));
  });
}

export function useChannelPlugins() {
  const [plugins, setPlugins] = useState(pluginsCache || []);

  useEffect(() => {
    fetchPlugins().then(setPlugins);

    listeners.add(setPlugins);
    return () => listeners.delete(setPlugins);
  }, []);

  return plugins;
}

/**
 * true se algum plugin declara uma action neste slot.
 *
 * Use em hot paths (ex: cada mensagem da lista) para só montar o
 * <PluginBridge> quando há plugin de fato — evita render à toa em centenas
 * de itens.
 */
export function useHasSlot(slot) {
  const plugins = useChannelPlugins();
  return plugins.some((p) =>
    (p.provides?.actions || []).some((a) => a.slot === slot)
  );
}

export default function ChannelIcon({ channel, style = {} }) {
  const plugins = useChannelPlugins();

  const plugin = plugins.find((p) => p.channel === channel);

  if (plugin) {
    const IconComp = iconMap[plugin.icon] || ChatIcon;
    return <IconComp style={{ color: plugin.color, ...style }} />;
  }

  const native = nativeChannels[channel];
  if (native) {
    const IconComp = iconMap[native.icon];
    if (IconComp) return <IconComp style={{ color: native.color, ...style }} />;
  }

  return <ChatIcon style={{ color: "#999", ...style }} />;
}
